import { allocation } from '../modals'
import { useBeds } from './useBeds'

type props = {
  locationName: string
  setLocationName: (e: string) => void
}
const LocationFilter = ({ locationName, setLocationName }: props) => {
  const locations = useBeds()
  const route = allocation?.bedManagementRoute
  return (
    <>
      <div>
        {route === allocation?.bedManagementRoute ? (
          <>
            <div className='lms-filters'>
              <div>
                <select
                  className='category-filter'
                  name='location'
                  value={locationName}
                  onChange={(e) => setLocationName(e.target.value)}
                >
                  {locations?.map((op: any, i: number) => (
                    <option key={i} value={op}>
                      {op}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </>
        ) : null}
      </div>
    </>
  )
}
export default LocationFilter
